export default __webpack_public_path__ + "postMock-1746537617973.html";